import(/* webpackMode: "eager" */ "/home/runner/work/kuden-legend/kuden-legend/frontend/business/src/app/global-error.tsx");
